export default "__VITE_ASSET__BfoiwRJZ__"